import api from './api.js';

export const settingsService = {
  getPublicSettings: () => api.get('/settings/public', false),
};

export default settingsService;
